(() => {
  'use strict';
  const script = document.querySelector('script[data-km-i18n]');
  if (!script) return;
  const parameters = new URLSearchParams(location.search);
  const previewKey = 'kitomasgota-preview-locale:' + script.dataset.theme;
  let preview = false;
  if (script.dataset.draft === 'true') {
    try {
      if (parameters.get('km_preview_locale') === 'off') sessionStorage.removeItem(previewKey);
      if (parameters.get('km_preview_locale') === 'pt-PT') sessionStorage.setItem(previewKey, 'pt-PT');
      preview = sessionStorage.getItem(previewKey) === 'pt-PT';
    } catch (error) { preview = parameters.get('km_preview_locale') === 'pt-PT'; }
  }
  const translatedLocale = /^(?:pt(?:-PT)?|fr(?:-FR)?|it(?:-IT)?)$/i.test(script.dataset.locale || '');
  if (!preview && !translatedLocale) return;
  let dictionary = Object.create(null);
  let observer;
  let patterns = [];
  const richFields = new Map();
  const renderedText = new WeakMap();
  const renderedAttributes = new WeakMap();
  const normalize = value => value.replace(/\s+/g, ' ').trim();
  const translate = value => {
    if (typeof value !== 'string') return value;
    const trimmed = value.trim();
    let replacement = dictionary[trimmed] ?? dictionary[normalize(trimmed)];
    if (replacement === undefined) {
      const decorated = trimmed.match(/^(.*?)(\s*[↗→↓↑▶+]\s*)$/);
      if (decorated) {
        const label = dictionary[decorated[1].trim()] ?? dictionary[normalize(decorated[1])];
        if (label !== undefined) replacement = label + decorated[2];
      }
    }
    if (replacement === undefined) {
      for (const pattern of patterns) {
        const match = normalize(trimmed).match(pattern.regex);
        if (!match) continue;
        replacement = pattern.target.replace(/{{\s*(\w+)\s*}}/g, (token,name) => {
          const index = pattern.names.indexOf(name);
          return index < 0 ? token : match[index + 1];
        });
        break;
      }
    }
    return replacement === undefined ? value : value.slice(0, value.indexOf(trimmed)) + replacement + value.slice(value.indexOf(trimmed) + trimmed.length);
  };
  window.KitomasgotaI18n = { text: translate };
  const apply = root => {
    observer?.disconnect();
    if (preview && root.querySelectorAll) {
      for (const element of root.querySelectorAll('[data-km-resource-hash],.tradepro-product-description,.tradepro-article-content,.tradepro-page-rte,.tradepro-collection-hero__text')) {
        const target = dictionary['__html_' + element.dataset.kmResourceHash] ?? richFields.get(element.innerHTML.trim());
        if (element.dataset.kmHtmlTranslated === 'true') continue;
        if (target === undefined) continue;
        element.innerHTML = target;
        element.dataset.kmHtmlTranslated = 'true';
        const translated = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
        let child;
        while ((child = translated.nextNode())) renderedText.set(child, child.nodeValue);
      }
    }
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.parentElement || node.parentElement.closest('script,style,textarea,[contenteditable="true"]')) return NodeFilter.FILTER_REJECT;
        return node.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    let node;
    while ((node = walker.nextNode())) {
      if (renderedText.get(node) === node.nodeValue) continue;
      const result = translate(node.nodeValue);
      if (result !== node.nodeValue) node.nodeValue = result;
      renderedText.set(node, result);
    }
    if (root.querySelectorAll) {
      for (const element of root.querySelectorAll('[title],[alt],[aria-label],[placeholder]')) {
        for (const attribute of ['title', 'alt', 'aria-label', 'placeholder']) {
          const value = element.getAttribute(attribute);
          if (value !== null) {
            let tracked = renderedAttributes.get(element);
            if (!tracked) { tracked = Object.create(null); renderedAttributes.set(element, tracked); }
            if (tracked[attribute] === value) continue;
            const result = translate(value);
            if (result !== value) element.setAttribute(attribute, result);
            tracked[attribute] = result;
          }
        }
      }
    }
    observer?.observe(document.documentElement, {subtree: true, childList: true, characterData: true});
  };
  const start = async () => {
    try {
      const dictionaryUrl = new URL(preview ? script.dataset.previewDictionary : script.dataset.dictionary, location.href);
      const response = await fetch(dictionaryUrl, {credentials:'same-origin'});
      if (!response.ok) return;
      let raw = await response.json();
      if (Array.isArray(raw.__parts)) {
        const patterns = raw.__patterns || [];
        const fragments = await Promise.all(raw.__parts.map(async file => {
          const partResponse = await fetch(new URL(file, dictionaryUrl), {credentials:'same-origin'});
          if (!partResponse.ok) throw new Error('Translation part unavailable');
          return partResponse.json();
        }));
        raw = Object.assign({}, ...fragments, {__patterns:patterns});
      }
      dictionary = Object.create(null);
      patterns = (raw.__patterns || []).map(item => {
        const names = [];
        const parts = item.source.split(/{{\s*(\w+)\s*}}/g);
        let regex = '^';
        for (let i = 0; i < parts.length; i++) {
          if (i % 2) { names.push(parts[i]); regex += '(.+?)'; }
          else regex += parts[i].replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s*');
        }
        return {regex:new RegExp(regex + '$'), names, target:item.target};
      });
      for (const [source,target] of Object.entries(raw)) {
        if (typeof target !== 'string') continue;
        dictionary[source] = target;
        if (preview && /<\/?(?:p|div|h[1-6]|ul|ol|table)\b/i.test(source)) {
          const template = document.createElement('template');
          template.innerHTML = source;
          richFields.set(template.innerHTML.trim(), target);
        }
        dictionary[normalize(source)] = target;
      }
      if (!preview) {
        const existing = document.createTreeWalker(document.documentElement, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = existing.nextNode())) renderedText.set(node, node.nodeValue);
        for (const element of document.querySelectorAll('[title],[alt],[aria-label],[placeholder]')) {
          const tracked = Object.create(null);
          for (const attribute of ['title','alt','aria-label','placeholder']) tracked[attribute] = element.getAttribute(attribute);
          renderedAttributes.set(element, tracked);
        }
      }
      let pending = false;
      observer = new MutationObserver(() => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => { pending = false; apply(document.documentElement); });
      });
      apply(document.documentElement);
      if (preview) {
        document.documentElement.lang = 'pt-PT';
        document.documentElement.dataset.kmPrivatePreview = 'pt-PT';
      }
    } catch (error) { console.warn('Kitomasgota translation dictionary unavailable.'); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
